var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-40 pb-80 w-full lg:pt-15 px-10"},[_c('Top',{attrs:{"title":"Инструкции","font":{ size: 22, leading: 22 }}}),(_vm.loading)?_c('spinner'):_vm._e(),_c('doc-items',{attrs:{"docs":_vm.docs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }